import { Category } from './enums';

export enum VendorApp {
  Modalyst = 'MODALYST',
  AutoDs = 'AUTODS',
  ZenDrop = 'ZENDROP',
}

export const vendorCategoryMap: Record<VendorApp, Partial<Record<Category, string>>> = {
  [VendorApp.Modalyst]: {
    [Category.WomensFashion]: 'rts.womensFashion',
    [Category.MensFashion]: 'rts.mensFashion',
    [Category.JewelryAccessories]: 'rts.jewelryAccessories',
    [Category.KidsBabies]: 'rts.kidsBabies',
    [Category.BeautyHealth]: 'rts.beautyHealth',
    [Category.HomeGarden]: 'rts.homeGarden',
    [Category.SportsEntertainment]: 'rts.sportsEntertainment',
    [Category.BagsLuggage]: 'rts.bagsLuggage',
    [Category.ConsumerElectronics]: 'rts.consumerElectronics',
    [Category.Pets]: 'rts.pets',
  },
  [VendorApp.AutoDs]: {
    [Category.WomensFashion]: '1',
    [Category.ConsumerElectronics]: '2',
    [Category.HomeGarden]: '3',
    [Category.Pets]: '4',
    [Category.SportsEntertainment]: '5',
  },
  // TODO update zendrop niche value
  [VendorApp.ZenDrop]: {
    [Category.WomensFashion]: 'womens_fashion',
    [Category.MensFashion]: 'mens_fashion',
    [Category.JewelryAccessories]: 'jewelry_accessories',
    [Category.KidsBabies]: 'kids_babies',
    [Category.BeautyHealth]: 'beauty_health',
    [Category.HomeGarden]: 'home_garden',
    [Category.SportsEntertainment]: 'sports_entertainment',
    [Category.BagsLuggage]: 'bags_luggage',
    [Category.ConsumerElectronics]: 'consumer_electronics',
    [Category.Pets]: 'pets',
  },
};
